// extracted by mini-css-extract-plugin
export default {"button":"PromotionTypesTable__button-rCdbb"};